window.addEventListener('DOMContentLoaded', () => {

  const swiper = new Swiper('.teaser_swiper', {
    spaceBetween: 24,
    autoHeight: false,
    speed: 500,
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      740: {
        slidesPerView: 2,
        slidesPerGroup: 2
      },
      1400: {
        slidesPerView: 3,
        slidesPerGroup: 3
      }
    }
  });

});



